import { classNames } from '@ember-decorators/component';
import PaperButton from 'ember-paper/components/paper-button';

@classNames('linced-only__button')
export default class LincedButton extends PaperButton {}
